import { render, staticRenderFns } from "./NoCard.vue?vue&type=template&id=5a94d690&scoped=true"
import script from "./NoCard.vue?vue&type=script&lang=js"
export * from "./NoCard.vue?vue&type=script&lang=js"
import style0 from "./NoCard.vue?vue&type=style&index=0&id=5a94d690&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a94d690",
  null
  
)

export default component.exports